var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.563676 5.04838H3.73995V14.9977H0.563676V5.04838ZM2.13206 0C2.64169 0 3.13045 0.188865 3.49082 0.525048C3.85119 0.86123 4.05363 1.31719 4.05363 1.79263C4.05363 2.26806 3.85119 2.72402 3.49082 3.0602C3.13045 3.39638 2.64169 3.58525 2.13206 3.58525C1.07309 3.58525 0.25 2.78053 0.25 1.79263C0.25 0.804721 1.07309 0 2.13206 0ZM5.62264 5.04838H8.7594V6.43894C9.09187 5.97661 9.54139 5.59787 10.0682 5.33624C10.5949 5.0746 11.1827 4.93814 11.7795 4.93894H12.6421C14.6421 4.93894 16.25 6.47581 16.25 8.30472V15H13.1132V14.0853V9.62212C13.0743 8.4879 12.2506 7.60944 11.0348 7.60944C9.819 7.60944 8.79955 8.48732 8.76003 9.62212V15H5.62327L5.62264 5.04838Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.52fa5c3f0dd545a77b4054d8a1221197.svg";
export { ForwardRef as ReactComponent };